import { createContext, useContext } from "react"

export type UserRole = "member" | "owner"

export type CurrentUserData = {
  user: { id: number; name: string; email: string; provider: string | null } | null
  role: UserRole | null
  hasOrganization: boolean
  updateUser: (patch: { name?: string; email?: string }) => void
}

export const UserContext = createContext<CurrentUserData>({
  user: null,
  role: null,
  hasOrganization: false,
  updateUser: () => {},
})

export const useCurrentUser = () => useContext(UserContext)
